import React from 'react';
import { isEmpty } from 'lodash';
import { FieldChangeGrid } from '@pages/admin/audit-log/change-grid';
import {
    getFieldChangeItems,
    getProcessedFieldChangeItems,
    removePropertiesFromObject,
} from '@pages/admin/audit-log/service';
import { useTranslation } from '@hooks/index';

type SubjectObservationAuditRecord = {
    Type?: number;
    OwnerName?: string;
    Owner?: { Name?: string };
};

const fieldsToHide = [
    'ReviewId',
    'IsSystemGenerated',
    'Type',
    'PanelRef',
    'DataListingRef',
    'IsDeleted',
    'DatasetOpenedOn',
    'Owner',
    'OwnerId',
    'ClosedDatePopulatedOn',
];

const SubjectObservationsAuditLogGrid = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    if (isEmpty(oldRecord) && isEmpty(newRecord)) return null;

    const { t } = useTranslation();

    const getTypeLabel = (record: SubjectObservationAuditRecord) => {
        if (isEmpty(record)) return '';
        if (record.Type === 0) return t('auditLog:system');
        if (record.Type === 2) return t('auditLog:note');
        return t('auditLog:manual');
    };

    // Add uses OwnerName, Update uses Owner.Name
    const oldOwnerName = oldRecord.OwnerName ? oldRecord.OwnerName : oldRecord.Owner?.Name;
    const newOwnerName = newRecord.OwnerName ? newRecord.OwnerName : newRecord.Owner?.Name;

    const refactoredOldRecord = oldRecord
        ? {
              ...oldRecord,
              ...removePropertiesFromObject(oldRecord, fieldsToHide),
              Type: getTypeLabel(oldRecord),
              OwnerName: oldOwnerName,
          }
        : oldRecord;

    const refactoredNewRecord = newRecord
        ? {
              ...newRecord,
              ...removePropertiesFromObject(newRecord, fieldsToHide),
              Type: getTypeLabel(newRecord),
              OwnerName: newOwnerName,
          }
        : newRecord;

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({ oldRecord, newRecord, oldItem, newItem, field }),
    );

    return <FieldChangeGrid items={items} />;
};

export default SubjectObservationsAuditLogGrid;
